import { combineReducers } from "redux";
import { PdfReducer } from "./pdf-reducer";
import Tutorial from "./tutorial-reducer";
import TopBarReducer from "./top-bar-reducer";
import GlobalsReducer from "./globals-reducer";
import ViewportReducer from "./viewport-reducer";
import { ProjectReducer } from "./project-reducer";
import StoneBedReducer from "./stone-bed-reducer";
import PDFDialogReducer from "./pdfdialog-reducer";
import ScaleLineReducer from "./scaleline-reducer";
import AppToolbarReducer from "./apptoolbar-reducer";
import { BackgroundReducer } from "./background-reducer";
import ModalAlertReducer from "./modal-alert.reducer";
import MeasureToolReducer from "./measuretool-reducer";
import CalculationsReducer from "./calculations-reducer";
import SystemParametersReducer from "./system-parameters-reducer";
import SubmitDialogReducer from "./submit-dialog-reducer";
import FloatingToolReducer from "./floating-tool-reducer";
import DebugingToolReducer from "./debuging-tool-reducer";
import PipeGlobals from "./pipe-globals-reducer";
import { ProjectsCrudReducer } from "./projects-crud-reducer";
import DrawingToolbarReducer from "./drawingtoolbar-reducer";
import AuthenticationReducer from "./authentication-reducer";
import AddRemoveToolReducer from "./add-remove-tool-reducer";
import { ProjecstAdminReducer } from "./projects-admin-reducer";
import { PipeBedReducer } from './pipe-bed-reducer';
import FloatingToolPipesReducer from "./floating-tool-pipes-reducer";
import { UpperManifoldReducer, LowerManifoldReducer, MainManifoldReducer } from "./main-manifold-reducer";
import { LocalizationReducer } from "./localization-reducer";
import BulkAddRemoveToolReducer from "./bulkaddremovetool-reducer";
import { ManifoldEntryReducer } from "./manifold-entry-reducer";
import { currentSelectedChamberReducer } from "./current-selected-chamber-reducer";
import {ChamberBedReducer} from "./chamber-bed-reducer";
import {MultiBedReducer} from "./multi-bed-reducer";
import { SubProjectReducer } from "./sub-project-reducer";
import FloatingToolInsertaTee from "./floating-tool-inserta-tee-reducer";
import FloatingToolInspectionPort from "./floating-tool-inspection-port-reducer";
import AccordionReducer from './accordion-reducer';

/**
 * Combine and export all reducers.
 * Reducers sorted from A-Z to easy find them in Redux devtools
 */
export default combineReducers({
  project: ProjectReducer,
  projectsAdmin: ProjecstAdminReducer,
  projectsCrud: ProjectsCrudReducer,
  subProject: SubProjectReducer,

  globals: GlobalsReducer,
  localization: LocalizationReducer,

  addremovetool: AddRemoveToolReducer,
  apptoolbar: AppToolbarReducer,
  authentication: AuthenticationReducer,
  background: BackgroundReducer,
  bulkAddRemoveTool: BulkAddRemoveToolReducer,
  calculations: CalculationsReducer,
  systemParameters: SystemParametersReducer,

  debugingtool: DebugingToolReducer,
  drawingToolbar: DrawingToolbarReducer,
  floatingtool: FloatingToolReducer,
  floatingtoolpipes: FloatingToolPipesReducer,
  floatingToolInsertaTee: FloatingToolInsertaTee,
  floatingToolInspectionPort: FloatingToolInspectionPort,

  measuretool: MeasureToolReducer,
  modalAlert: ModalAlertReducer,
  pdf: PdfReducer,
  pdfdialog: PDFDialogReducer,
  pipeGlobals: PipeGlobals,
  pipeBed: PipeBedReducer,

  scaleline: ScaleLineReducer,
  submitdialog: SubmitDialogReducer,
  stonebed: StoneBedReducer,
  topbar: TopBarReducer,
  tutorial: Tutorial,

  viewport: ViewportReducer,

  accordion: AccordionReducer,

  chamberbed: ChamberBedReducer,
  currentSelectedChamber: currentSelectedChamberReducer,

  mainManifolds: MainManifoldReducer,
  upperManifolds: UpperManifoldReducer,
  lowerManifolds: LowerManifoldReducer,
  manifoldEntry: ManifoldEntryReducer,

  multiBed: MultiBedReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js